(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.predictiveSearch = document.querySelector('predictive-search');
      this.menumb = document.querySelector('#Details-menu-drawer-container');
      this.btnCloseMenu = document.querySelector('.btn-close-menumb');

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.btnCloseMenu.addEventListener('click', this.closeMenu.bind(this));
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }
    closeMenu() {
    console.log('headerliquid close')


      this.menumb.classList.remove('menu-opening');
      this.menumb.removeAttribute('open');
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom && scrollTop >= 250) {
      //   if (this.preventHide) return;
      //   requestAnimationFrame(this.hide.bind(this));
      // } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      //   if (!this.preventReveal) {
      //     requestAnimationFrame(this.reveal.bind(this));
      //   } else {
      //     window.clearTimeout(this.isScrolling);

      //     this.isScrolling = setTimeout(() => {
      //       this.preventReveal = false;
      //     }, 66);

      //     requestAnimationFrame(this.hide.bind(this));
      //   }
      // } else if (scrollTop <= this.headerBounds.top) {
      //   requestAnimationFrame(this.reset.bind(this));
      // }

      // this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    const cartOpener = document.querySelector('.menu-drawer__cart-opener');
    const menuDrawer = document.getElementById('menu-drawer');
    const menuDrawer2 = document.getElementById('Details-menu-drawer-container');


    if (cartOpener && menuDrawer) {
      cartOpener.addEventListener('click', () => {
        // Fermer le menu drawer
        menuDrawer2.removeAttribute('open');
      });
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t-image-text-v5"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ... garde ton code existant au-dessus

  function playHTML5(vid, scope, idx){
    try{
      // requis iOS
      vid.setAttribute('playsinline','');
      vid.setAttribute('webkit-playsinline','');
      vid.playsInline = true;

      // tentative 1: lecture normale
      let p = vid.play();
      if (p && typeof p.catch === 'function'){
        p.catch(function(err){
          console.warn('[505#'+idx+' '+scope+'] play refusé (1) → retry muted', err);
          // tentative 2: muted (autorisé partout)
          try{
            vid.muted = true;
            let p2 = vid.play();
            if (p2 && typeof p2.catch === 'function'){
              p2.catch(function(err2){
                console.warn('[505#'+idx+' '+scope+'] play refusé même muted', err2);
              });
            }
          }catch(e2){ console.warn('[505#'+idx+' '+scope+'] erreur retry muted', e2); }
        });
      }
      vid.controls = true;

    }catch(e){
      console.warn('[505#'+idx+' '+scope+'] HTML5 play error', e);
    }
  }

  function bind(el, scope, root, container, tzDesktop, tzMobile, idx){
    if(!el){ console.warn('[505#'+idx+' '+scope+'] overlay introuvable'); return; }

    // handler synchrone: on fait tout DANS l’event, sans setTimeout/Promise.then
    function handler(ev){
      // devine le media visible MAINTENANT
      var frame = (function(){
        var list = container.querySelectorAll('iframe');
        for (var i=0;i<list.length;i++){
          var cs = getComputedStyle(list[i]);
          if (cs.display!=='none' && cs.visibility!=='hidden' && list[i].offsetWidth>0 && list[i].offsetHeight>0) return list[i];
        }
        return null;
      })();

      var video = (function(){
        var list = container.querySelectorAll('video');
        for (var i=0;i<list.length;i++){
          var cs = getComputedStyle(list[i]);
          if (cs.display!=='none' && cs.visibility!=='hidden' && list[i].offsetWidth>0 && list[i].offsetHeight>0) return list[i];
        }
        return null;
      })();

      console.log('[505#'+idx+' '+scope+'] tap');

      if (frame){
        console.log('[505#'+idx+' '+scope+'] cible = iframe (YouTube)');
        playYouTube(frame, scope, idx);
      } else if (video){
        console.log('[505#'+idx+' '+scope+'] cible = <video> HTML5');
        playHTML5(video, scope, idx);
      } else {
        console.warn('[505#'+idx+' '+scope+'] aucun média visible trouvé');
        return;
      }

      // on cache l’overlay après confirmation de démarrage
      function onPlayingOnce(){
        tzDesktop && (tzDesktop.style.display='none');
        tzMobile  && (tzMobile.style.display='none');
        video && video.removeEventListener('playing', onPlayingOnce);
      }
      // si c’est YouTube, on n’a pas d’event → on cache quand même après 100ms
      setTimeout(function(){
        tzDesktop && (tzDesktop.style.display='none');
        tzMobile  && (tzMobile.style.display='none');
      }, 100);

      if (video) video.addEventListener('playing', onPlayingOnce, {once:true});
    }

    // IMPORTANT: évènements qui comptent comme "user gesture" partout
    el.addEventListener('click', handler, {capture:false});
    el.addEventListener('touchend', handler, {passive:true, capture:false});

    console.log('[505#'+idx+' '+scope+'] overlay prêt');
  }

  // ... et plus bas, dans roots.forEach(...)
  var roots = document.querySelectorAll('.section-505');
  if (!roots.length) return;

  roots.forEach(function(root, idx){
    var container = root.querySelector('.section-505__image');
    if(!container){ console.warn('[505#'+idx+'] pas de .section-505__image'); return; }

    var tzDesktop = root.querySelector('.section-505__tapzone.is-desktop');
    var tzMobile  = root.querySelector('.section-505__tapzone.is-mobile');

    // s'il n'existe pas, crée-les vite-fait pour les tests
    if(!tzDesktop){ tzDesktop = document.createElement('span'); tzDesktop.className='section-505__tapzone is-desktop'; container.appendChild(tzDesktop); }
    if(!tzMobile){  tzMobile  = document.createElement('span'); tzMobile.className='section-505__tapzone is-mobile';  container.appendChild(tzMobile); }

    // min styles pour cliquer même sans CSS
    [tzDesktop, tzMobile].forEach(function(el){
      el.style.position='absolute'; el.style.inset='0'; el.style.zIndex='3'; el.style.display='block';
    });

    bind(tzDesktop, 'desktop', root, container, tzDesktop, tzMobile, idx);
    bind(tzMobile,  'mobile',  root, container, tzDesktop, tzMobile, idx);
  });

  // ... garde ton code en dessous si besoin
})();

  } catch(e) { console.error(e); }
})();
})();
